export default function InstructorActionBar({
  autosaveStatus,
  formDirty,
  practicalEnabled,
  busy,
  onSaveDraft,
  onApprovePublish,
  showGenerate,
  onGenerate,
}) {
  const unsaved = formDirty || autosaveStatus === "retry" || autosaveStatus === "saving";
  const saved = autosaveStatus === "saved" && !formDirty;

  let statusLabel = "UNSAVED CHANGES";
  let subLabel = "Nothing has been sent to the learner yet.";
  if (autosaveStatus === "saving") {
    statusLabel = "SAVING TRAINING DRAFT…";
    subLabel = "Please wait while your training draft is saved.";
  } else if (saved) {
    statusLabel = "TRAINING DRAFT SAVED";
    subLabel = "Training draft saved to the server. Approve & publish when ready.";
  } else if (autosaveStatus === "retry") {
    statusLabel = "SAVE ERROR";
    subLabel = "Unable to save — retry Save draft.";
  } else if (!unsaved && autosaveStatus === "idle") {
    statusLabel = "READY";
    subLabel = "Nothing has been sent to the learner yet.";
  }

  return (
    <div className="audit-action-bar" role="status" aria-live="polite" data-testid="audit-action-bar">
      <div className="audit-action-bar-inner">
        <div>
          <div className="audit-action-status" data-testid="qdf-autosave-status">
            {statusLabel}
          </div>
          <div className="audit-action-sub">{subLabel}</div>
        </div>
        <div className="audit-action-buttons">
          {showGenerate && (
            <button
              type="button"
              className="audit-btn-save-draft"
              onClick={onGenerate}
              disabled={!practicalEnabled || busy}
              data-testid="qdf-generate-feedback"
            >
              Generate AI Draft
            </button>
          )}
          <button
            type="button"
            className="audit-btn-save-draft"
            onClick={onSaveDraft}
            disabled={!practicalEnabled || busy}
            data-testid="qdf-manual-save"
          >
            Save Draft
          </button>
          <button
            type="button"
            className="audit-btn-publish"
            onClick={onApprovePublish}
            disabled={!practicalEnabled || busy}
            data-testid="qdf-approve-publish"
          >
            Approve &amp; Publish
          </button>
        </div>
      </div>
    </div>
  );
}
